import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

export type breadcrumb = {
  title: string;
  onClick?: () => void;
};

interface indexedBreadcrumb extends breadcrumb {
  breadcrumbIndex?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  props: {
    value: null,
    dividerIcon: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value?: breadcrumb[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: breadcrumb[];
  dividerIcon?: string;
};





const indexedBreadcrumbs = computed({
  get: () => {
    // Appending a breadcrumbIndex key
    return props.value && props.value.map((breadcrumb: breadcrumb, index) => {
      return {
        ...breadcrumb,
        breadcrumbIndex: index,
      };
    });
  },
  set: (newBreadcrumbNavigation?: indexedBreadcrumb[]) => {
    emit(
      "input",
      newBreadcrumbNavigation && newBreadcrumbNavigation.map(
        function (item) {
          delete item.breadcrumbIndex;
          return item;
        }
      )
    );
  },
});

function onBreadcrumbClick(index: number, callback?: () => void) {
  if (index < indexedBreadcrumbs.value!.length - 1) {
    const updatedBreadcrumbNavigation = indexedBreadcrumbs.value && indexedBreadcrumbs.value.filter(
      (breadcrumb: indexedBreadcrumb) => breadcrumb.breadcrumbIndex! <= index
    );
    indexedBreadcrumbs.value = updatedBreadcrumbNavigation;
  }

  callback && callback();
}

return { __sfc: true,emit, props, indexedBreadcrumbs, onBreadcrumbClick }
}

})